module.exports = __webpack_public_path__ + "img/logo_monefy.8adcdefe.png";